export enum applicationType {
  common = 'CommonApp', // generic application
  company = 'CompanyApp', // site connected to company
  course = 'CourseApp', // site connected to course
  mosaico = 'MosaicoApp', // mosaico application
}
